import { render, staticRenderFns } from "./BannerPhone.vue?vue&type=template&id=0cdbe058&scoped=true"
import script from "./BannerPhone.vue?vue&type=script&lang=js"
export * from "./BannerPhone.vue?vue&type=script&lang=js"
import style0 from "./BannerPhone.vue?vue&type=style&index=0&id=0cdbe058&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbe058",
  null
  
)

export default component.exports